import React, {useState, useEffect} from "react"
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_UPDATED_BY, ATTR_UPDATED_MS_I,
    ATTR_OBJ_STATE,
    awaitMakeBookMark,
    OBJ_STATE_TO_DEL,
    OBJ_TYPE_BMARK,
    OBJ_TYPE_BMARK_TABLE_DEF,
    subscribeToBookmarksChanged,
    unSubscribeToBookmarksChanged, STR_YES, STR_NO,
    VIEW_MODE_CALENDAR, VIEW_MODE_TABLE, getDisclaimerWhyDisabled, UI_LISTED_ELEMENTS_LIMIT,
} from "../prodect/ProsConnect";
import {setHelpContext} from "../prodect/HelpManager";
import {formatDate} from "../prodect/ProsCommonUi";
import LoadingAnimation from "../components/LoadingAnimation";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import DropdownMenu from "../components/DropdownMenu";
import RadioButton from "../components/RadioButton";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import TextInput from "../components/TextInput";
import Pagination from "../components/Pagination";

// Bookmark
//      - is private when ATTR_IS_PRIVATE is STR_YES, otherwise BM is shared, owner in ATTR_EMAIL
//      - UI view mode is in ATTR_UI_VIEW_MODE - 'list' | 'table' | 'matrix'
//      - who & when last update is in ATTR_UPDATED_BY, ATTR_UPDATED_MS_I

// Book mark 'scope' is not yet stored but could be expended from current "per sub-project" as
//      - per main project or
//      - per customer
// Server is prepared to support wider scope by storing book marks and project links "by customer"
// If would extended book mark for wider scope need to
//      - let user to choose 'scope' and save it into BM
//      - change server book mark fetch filtering
//      - filter out book marks to sub-project for which user has no permission / role
//      - change Home to load selected project when book mark been selected

// Bookmark list view
export default function Bookmarks(props) {
    const [loading, setLoading] = useState(true)
    const [bookmarkList, setBookmarkList] = useState(undefined)

    useEffect(() => {
        function refreshBookmarks(bookMarks, currentBookMark) {
            setBookmarkList(bookMarks)
            setLoading(false)
        }
        // UI component mounted - subscribe to get notification when BM loaded or changed
        setHelpContext('bookmarks')
        subscribeToBookmarksChanged(refreshBookmarks, 'any')
        // Specify how to clean up after this effect:
        return function cleanup() {
            unSubscribeToBookmarksChanged(props.viewMode);
        }
    }, [props])

    const showDeletePopup = bookmark => {
        BasicModal('Poista kirjanmerkki',
        'Oletko varma? Poistettua kirjanmerkkiä ei voi palauttaa.',
        {
            action: ()=>{
                deleteBookmark(bookmark)
            },
            btnType: 'fatal',
            btnText: 'Poista'
        })
    }

    const openLinkToBookmark = (bookMark) => {
        // propagate book mark open req to Home
         if(typeof props.openLinkToBookmark === 'function') props.openLinkToBookmark(bookMark)
    }

    const deleteBookmark = async (bookmark) => {
        bookmark[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
        await prosConnect.awaitUpdateBookMark(bookmark)
        BasicModalDismiss()
    }

    if (loading) {
        return <LoadingAnimation size={"lg"} />
    }

    return <div className={"grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd"}>
        <div>
            <h2>Omat</h2>
            <BookmarksList
                bookmarkList={bookmarkList}
                showDeletePopup={showDeletePopup}
                openLinkToBookmark={openLinkToBookmark}
                is_private={STR_YES}
            />
        </div>
        <div>
            <h2>Jaetut</h2>
            <BookmarksList
                bookmarkList={bookmarkList}
                showDeletePopup={showDeletePopup}
                openLinkToBookmark={openLinkToBookmark}
                is_private={STR_NO}
            />
        </div>
    </div>
}

function renderBookMarkCreated(bookMark) {
    let updatedBy = bookMark[ATTR_UPDATED_BY]
    let whenUpdated = formatDate(bookMark[ATTR_UPDATED_MS_I], true)
    return <section className={"text-sm"}>
        <p className={"margin-0"}>{whenUpdated} {updatedBy}</p>
    </section>
}

function BookmarksList({bookmarkList, showDeletePopup, openLinkToBookmark, is_private}) {
    const [page, setPage] = useState(0)
    if (!bookmarkList || bookmarkList.length < 1) {
        return <p>Ei kirjanmerkkejä.</p>
    }
    const resultList = []
    bookmarkList.forEach((bookmark, i) => {
        if (bookmark.is_private === is_private) resultList.push(bookmark)
    })
    if(resultList.length < 1) return <p>Ei kirjanmerkkejä.</p>
    const chunkSize = UI_LISTED_ELEMENTS_LIMIT * 2//20 items per page
    const allPagesAmount = resultList.length
    const displayList = resultList.slice(page, page + chunkSize).map((bookmark, i) => {
        let icon = (bookmark.ui_view_mode === VIEW_MODE_CALENDAR ? 'calendar' : bookmark.ui_view_mode)
        let whyNotAllowed = getDisclaimerWhyDisabled("editObj", bookmark)
        return <div className={"inpage-box margin-bottom"} key={i}>
            <header>
                <h4
                    onClick={() => openLinkToBookmark(bookmark)}
                    className={"display-flex valign-center flex-grow"}
                >
                    <i className={"ui-icon ui-icon-" + icon}/>
                    <span className={"lnk"}>{bookmark.text}</span>
                </h4>
                <BasicButton
                    icon={"times"}
                    action={()=>{
                        showDeletePopup(bookmark)
                    }}
                    title={"Poista kirjanmerkki"}
                    disabled={whyNotAllowed}
                    tooltip={whyNotAllowed ? [whyNotAllowed, "tooltip-left_bottom"]: null}
                    btnType={whyNotAllowed ? "locked" : "prompt"}
                />
            </header>
            {renderBookMarkCreated(bookmark)}
        </div>
    })
    return <>
        {displayList}
        {allPagesAmount > chunkSize ? <Pagination
            btnClass={"3rd"}
            chunk={chunkSize}
            currentPage={page}
            allItemsInt={allPagesAmount}
            callback={val=> setPage(val)}
            showPages
            disableLoop
            className={"btn-set margin-top"}
        /> : null}
    </>
}



export function PromptCustomBookmarks(props) {
    const [text, setText] = useState('')
    const [selection, setSelection] = useState(1)

    function updateText(txt){
        setText(txt)
    }

    function updateParent(){
        props.setText(text, selection)
    }

    return <>
        <section>
            {(prosConnect.hasPermissionTo("editProject") ?
                <BookmarkSelectionGroup type="radio" updateValue={setSelection} viewMode={props.viewMode}/>
                : null)}
            <TextInput
                label={props.labelText}
                placeholder={selection < 3 ? props.placeHolder : 'Pois käytöstä'}
                value={selection < 3 ? text : '· · ·'}
                onChange={(val) => updateText(val)}
                autoFocus
                required={selection < 3}
                isValid={text.length > 0 && selection < 3}
                disabled={selection > 2}
                className={selection > 2 ? "not-visible" : null}
            />
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={()=> props.closePopup()}
                />
                <ConfirmButton
                    label={props.btnText}
                    action={()=> updateParent()}
                    disabled={text.length < 1 && selection < 3}
                />
            </div>
        </footer>
    </>
}

export function BookmarkSelectionGroup(props) {
    const [selection, setSelection] = useState(1);

    function updateValues(val){
        setSelection(val);
        props.updateValue(val);
    }

    return <div className={"selection-group selection-group-" + props.type}>
            <RadioButton
                checked={selection === 1}
                text="Tallenna omaksi kirjanmerkiksi"
                onChange={() => updateValues(1)}
            />

            <RadioButton
                checked={selection === 2}
                text="Tallenna jaetuksi kirjanmerkiksi"
                onChange={() => updateValues(2)}
            />

            {prosConnect.hasPermissionTo("editProject") && props.viewMode === VIEW_MODE_TABLE && (
                <RadioButton
                    checked={selection === 3}
                    text="Tallenna taulukon oletusasetukseksi"
                    onChange={() => updateValues(3)}
                />
            )}
        </div>
}

export function SaveBookMarkDialog(props) {
    return <PromptCustomBookmarks
        placeHolder="Anna kirjanmerkille nimi"
        labelText="Kirjanmerkin nimi"
        viewMode={props.viewMode}
        setText={async (text, type) => {
            let isSavingTableBookMark = props.viewMode === VIEW_MODE_TABLE;//table list matrix
            let isTableDefaults = false;
                //type 1 is private bookmark
                //type 2 is shared bookmark
                //type 3 is table-default bookmark
                if(type === 3 && isSavingTableBookMark){
                    isTableDefaults = true;
                    text = 'table_defaults';
                }

            let bookMarkType = (isTableDefaults && isSavingTableBookMark ? OBJ_TYPE_BMARK_TABLE_DEF : OBJ_TYPE_BMARK);
            let isPrivateBookMark = (type > 1 ? false : true);

            if (text.length > 0) {

                props.notifyParent("Tallennetaan..", false, false, true);

                if (await awaitMakeBookMark(text, bookMarkType, isPrivateBookMark)) {
                    props.notifyParent("Merkki tallennettu")
                } else {
                    props.notifyParent("Merkin teko epäonnistui", true, true)
                }
                props.closePopup()

            } else {
                props.notifyParent("Anna kirjanmerkille nimi")
            }
        }}
        closePopup={props.closePopup}
    />
}


export function BookMarksMenu(props) {
    const [bookmarkList, setBookmarkList] = useState(undefined)
    const [loading, setLoading] = useState(true)
    const [currentBookmark, setCurrentBookmark] = useState(-1)

    React.useEffect(() => {
        async function refreshBookmarks(bookMarks, currentBookMark) {
            setBookmarkList(bookMarks)
            setCurrentBookmark(currentBookMark)
            setLoading(false)
        }
        subscribeToBookmarksChanged(refreshBookmarks, props.viewMode)
        // Specify how to clean up after this effect:
        return function cleanup() {
            unSubscribeToBookmarksChanged(props.viewMode);
        };
    }, [props, loading]);

    useEffect(()=>{
        if (currentBookmark > -1) {
            props.openLinkToBookmark(bookmarkList[currentBookmark])
        }
    },[props, currentBookmark, bookmarkList])

    function formatBookmarkList(){
        let outputList = []
        if(!bookmarkList || bookmarkList.length < 1 || loading){
            outputList.push({value: null, text: 'Ei kirjanmerkkejä.', action: ()=>{return false}})
        }else{
            outputList = bookmarkList.map((bookmark, i) => {
                return {
                    value: i.toString(),
                    text: bookmark.text
                }
            }).reverse()
        }
        outputList.push({
            icon: 'plus',
            text: 'Lisää kirjanmerkki',
            action: ()=> props.showSaveToBooksmarks()
        })
        return outputList
    }

    return <DropdownMenu
        values={formatBookmarkList()}
        currentValue={currentBookmark}
        onSelect={(val)=>{
            props.openLinkToBookmark(bookmarkList[val])
        }}
        text={false}
        icon={"bookmark"}
        btnClass={"3rd"}
        tooltip={["Kirjanmerkit"]}
        className={"ui-dropdown-align-right"}
    />
}